import { render } from "./SearchMinusIcon.vue?vue&type=template&id=3eab8b4d"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__